import { get } from 'lodash';

import { ColumnType } from '@inqool/uas-web-core/es/components/controls/Grid/constants';
import { educationTypeEnum, fuelTypeEnum } from '@modules/dictionary/_dictionaryEnums';
import { formatToDecimals } from '@utils/utils';

export const order = {
  label: 'Pořadí',
  field: 'order',
  type: ColumnType.NUMBER,
  width: 200
};

export const name = {
  label: 'Název',
  field: 'name',
  type: ColumnType.TEXT,
  width: 200
};

export const active = {
  label: 'Aktivní',
  field: 'active',
  type: ColumnType.BOOLEAN,
  width: 200
};

export const code = {
  label: 'Kód',
  field: 'code',
  type: ColumnType.NUMBER,
  width: 200
};

export const stationCode = {
  label: 'Kód',
  field: 'code',
  type: ColumnType.TEXT,
  width: 200
};

export const shreddingSymbol = {
  label: 'Skartační znak',
  field: 'shreddingSymbol',
  type: ColumnType.TEXT,
  width: 200
};

export const shreddingPeriod = {
  label: 'Skartační lhůta',
  field: 'shreddingPeriod',
  type: ColumnType.TEXT,
  width: 200
};

export const country = {
  label: 'Stát',
  field: 'country.name',
  displayField: 'country',
  mapper: o => get(o, 'name'),
  type: ColumnType.TEXT,
  width: 200
};

export const region = {
  label: 'Kraj',
  field: 'region.name',
  displayField: 'region',
  mapper: o => get(o, 'name'),
  type: ColumnType.TEXT,
  width: 200
};

export const county = {
  label: 'Okres',
  field: 'county.name',
  displayField: 'county',
  mapper: o => get(o, 'name'),
  type: ColumnType.TEXT,
  width: 200
};

export const municipality = {
  label: 'Obec',
  field: 'municipality.name',
  displayField: 'municipality',
  mapper: o => get(o, 'name'),
  type: ColumnType.TEXT,
  width: 200
};

export const municipalitypart = {
  label: 'Část obce',
  field: 'municipalitypart.name',
  displayField: 'municipalitypart',
  mapper: o => get(o, 'name'),
  type: ColumnType.TEXT,
  width: 200
};

export const street = {
  label: 'Ulice',
  field: 'street',
  type: ColumnType.TEXT,
  width: 200
};

export const fullAddress = {
  label: 'Adresa',
  field: 'address.fullAddress',
  displayField: 'address',
  mapper: o => get(o, 'fullAddress'),
  type: ColumnType.TEXT,
  width: 200
};

export const reminder = {
  label: 'Upozornění',
  field: 'reminder',
  type: ColumnType.NUMBER,
  width: 200
};

export const fullName = {
  label: 'Celý název',
  field: 'fullName',
  type: ColumnType.TEXT,
  width: 300
};

export const template = {
  label: 'Šablona',
  field: 'template',
  type: ColumnType.TEXT,
  width: 200
};

export const law = {
  label: 'Zákon',
  field: 'law',
  type: ColumnType.TEXT,
  width: 200
};

export const amendment = {
  label: 'Novela',
  field: 'amendment',
  type: ColumnType.TEXT,
  width: 200
};

export const paragraph = {
  label: 'Paragraf',
  field: 'paragraph',
  type: ColumnType.TEXT,
  width: 200
};

export const section = {
  label: 'Odstavec',
  field: 'section',
  type: ColumnType.NUMBER,
  width: 200
};

export const letter = {
  label: 'Písmeno',
  field: 'letter',
  type: ColumnType.TEXT,
  width: 200
};

export const pointOfLetter = {
  label: 'Bod',
  field: 'pointOfLetter',
  type: ColumnType.TEXT,
  width: 200
};

export const points = {
  label: 'Body',
  field: 'points',
  type: ColumnType.NUMBER,
  width: 100
};

export const description = {
  label: 'Popis',
  field: 'description',
  type: ColumnType.TEXT,
  width: 300
};

export const type = {
  label: 'Typ vozidla',
  field: 'type',
  displayField: 'vehicle',
  mapper: parent => get(parent, 'type'),
  type: ColumnType.TEXT,
  width: 200
};

export const brand = {
  label: 'Značka vozidla',
  field: 'brand',
  displayField: 'vehicle',
  mapper: parent => get(parent, 'brand'),
  type: ColumnType.TEXT,
  width: 200
};

export const color = {
  label: 'Barva vozidla',
  field: 'color',
  displayField: 'vehicle',
  mapper: parent => get(parent, 'color'),
  type: ColumnType.TEXT,
  width: 200
};
export const mileage = {
  label: 'Stav km',
  field: 'mileage',
  type: ColumnType.NUMBER,
  width: 200
};
export const fuelCosts = {
  label: 'Celkové náklady na palivo',
  field: 'fuelCosts',
  type: ColumnType.NUMBER,
  width: 200,
  mapper: v => formatToDecimals(v)
};
export const repairCosts = {
  label: 'Celkové náklady na opravy',
  field: 'repairCosts',
  type: ColumnType.NUMBER,
  width: 200,
  mapper: v => formatToDecimals(v)
};
export const fuelType = {
  label: 'Typ paliva',
  field: 'fuelType',
  type: ColumnType.ENUM,
  enum: fuelTypeEnum,
  width: 200
};
export const fuelConsumption = {
  label: 'Spotřeba na 100 km',
  field: 'fuelConsumption',
  type: ColumnType.NUMBER,
  width: 200
};
export const nextStkTest = {
  label: 'Datum příští STK',
  field: 'nextStkTest',
  type: ColumnType.DATETIME,
  width: 200
};

export const generalInspectionDate = {
  label: 'Datum kdy notifikovat o generální prohlídce',
  field: 'generalInspectionDate',
  type: ColumnType.DATETIME,
  width: 200
};

export const oilType = {
  label: 'Typ oleje',
  field: 'oilType',
  type: ColumnType.TEXT,
  width: 200
};
export const tireSize = {
  label: 'Typ Pneumatik',
  field: 'tireSize',
  type: ColumnType.TEXT,
  width: 200
};
export const lastInspection = {
  label: 'Nájezd při poslední prohlídce',
  field: 'lastInspection',
  type: ColumnType.TEXT,
  width: 200
};
export const nextInspection = {
  label: 'Nájezd při příští prohlídce',
  field: 'nextInspection',
  type: ColumnType.TEXT,
  width: 200
};
export const lastGeneralInspection = {
  label: 'Nájezd při poslední generální prohlídce',
  field: 'lastGeneralInspection',
  type: ColumnType.TEXT,
  width: 200
};
export const generalInspectionMileage = {
  label: 'Nájezd kdy notifikovat o generální prohlídce',
  field: 'generalInspectionMileage',
  type: ColumnType.TEXT,
  width: 200
};
export const callSign = {
  label: 'Volací znak',
  field: 'callSign.name',
  displayField: 'callSign',
  mapper: parent => get(parent, 'name'),
  type: ColumnType.TEXT,
  width: 200
};

export const format = {
  label: 'Formát',
  field: 'format',
  type: ColumnType.TEXT,
  width: 200
};

export const counter = {
  label: 'Hodnota',
  field: 'counter',
  type: ColumnType.TEXT,
  width: 200
};

export const registrationNumber = {
  label: 'Registrační číslo vozdila',
  field: 'vehicle.registrationNumber',
  displayField: 'vehicle',
  mapper: parent => get(parent, 'registrationNumber'),
  type: ColumnType.TEXT,
  width: 200
};
export const vinNumber = {
  label: 'VIN',
  field: 'vehicle.vinNumber',
  displayField: 'vehicle',
  mapper: parent => get(parent, 'vinNumber'),
  type: ColumnType.TEXT,
  width: 200
};

export const idNumber = {
  label: 'IČO',
  field: 'idNumber',
  type: ColumnType.TEXT,
  width: 200
};

export const contact = {
  label: 'Kontakt',
  field: 'contact',
  type: ColumnType.TEXT,
  width: 200
};

export const phoneNumber = {
  label: 'Telefon',
  field: 'phoneNumber',
  type: ColumnType.TEXT,
  width: 200
};

export const email = {
  label: 'E-mail',
  field: 'email',
  type: ColumnType.TEXT,
  width: 200
};
export const parentType = {
  label: 'Nadřazený typ',
  field: 'parent',
  mapper: parent => get(parent, 'name'),
  type: ColumnType.TEXT,
  width: 200
};

export const report = {
  label: 'Report',
  field: 'descriptionTemplate.name',
  displayField: 'descriptionTemplate',
  mapper: parent => get(parent, 'name'),
  type: ColumnType.TEXT,
  width: 200
};

export const educationType = {
  label: 'Typ vzdělání',
  field: 'type',
  type: ColumnType.ENUM,
  enum: educationTypeEnum,
  width: 200
};

export const violationLaw = {
  label: 'Zákon porušení',
  field: 'violationLaw',
  type: ColumnType.TEXT,
  width: 200
};

export const delictLaw = {
  label: 'Zákon přestupku',
  field: 'delictLaw',
  type: ColumnType.TEXT,
  width: 200
};

export const symbol = {
  label: 'Symbol',
  field: 'symbol',
  type: ColumnType.TEXT,
  width: 200
};

export default [order, name, active];



// WEBPACK FOOTER //
// ./src/modules/dictionary/_dictionaryColumns.ts